import { DesignHuddleAssetPreviewModal } from "./design-huddle-asset-preview-modal";
import { UploadedFileAssetPreviewModal } from "./uploaded-file-asset-preview-modal";

import type { Asset } from "./server/digital-asset-service";
import type { FC } from "react";

export const AssetPreviewModal: FC<{
  open: boolean;
  onClose: () => void;
  asset: Asset | null;
  onChange: () => void;
  onArchived?: () => void;
  onViewFileClick: (asset: Asset) => void;
  onFolderChange: () => void;
  folders_feature_flag?: boolean;
}> = ({
  asset,
  open,
  onClose,
  onChange,
  onArchived,
  onViewFileClick,
  onFolderChange,
  folders_feature_flag = false,
}) => {
  if (!asset) return null;

  return asset.content_type === "Uploaded File" ? (
    <UploadedFileAssetPreviewModal
      asset={asset}
      open={open}
      onClose={onClose}
      onChange={onChange}
      onArchived={onArchived}
      onViewFileClick={onViewFileClick}
      onFolderChange={onFolderChange}
      folders_feature_flag={folders_feature_flag}
    />
  ) : (
    <DesignHuddleAssetPreviewModal
      asset={asset}
      open={open}
      onClose={onClose}
      onChange={onChange}
      onFolderChange={onFolderChange}
      onArchived={onArchived}
      folders_feature_flag={folders_feature_flag}
    />
  );
};
